import React from 'react';
import { useHistory } from 'react-router-dom';
import ConfirmationModal from 'components/ConfirmationModal';
import Link from 'components/Link';
import Typography from 'components/Typography';
import { api } from 'hooks/api.hooks';
import { translate } from 'i18n';

const RestartEmailFlow: React.FC = () => {
  const [isModalVisible, setModalVisible] = React.useState(false);
  const history = useHistory();

  const handleConfirm = async () => {
    await api.post('/access-keys/email/cancel');
    history.push('/gegevens/aanmeldsleutels/e-mail/toevoegen');
  };

  const toggleModal = () => {
    setModalVisible(!isModalVisible);
  };

  return (
    <>
      <Typography variant="h2" as="h6" classNames={['u-margin-top', 'u-margin-bottom-xs']}>
        {translate('accessKeys.email.restart.title')}
      </Typography>

      <Link to="/gegevens/aanmeldsleutels/e-mail/" onClick={toggleModal}>
        {translate('accessKeys.email.restart.link')}
      </Link>

      <ConfirmationModal
        title="accessKeys.email.pending.modal.title"
        body="accessKeys.email.pending.modal.description"
        confirmLabel="accessKeys.email.pending.modal.confirm"
        cancelLabel="common.modal.cancel"
        onRequestClose={toggleModal}
        onConfirm={handleConfirm}
        isOpen={isModalVisible}
      />
    </>
  );
};

export default RestartEmailFlow;
